import React from "react";
import { formatCell, toTitleCase } from "./analyticsUtils";

const SummaryCards = ({ entries = [] }) => {
  if (!entries.length) {
    return (
      <div className="bg-gray-50 border rounded-md p-4 text-sm text-muted">
        No summary data.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      {entries.map(([key, value]) => (
        <div
          key={key}
          className="rounded-3xl border border-slate-200 bg-gradient-to-br from-white via-white to-slate-50 p-5 shadow-[0_10px_30px_rgba(15,23,42,0.05)]"
        >
          <div className="text-xs uppercase tracking-[0.14em] text-slate-500">
            {toTitleCase(key)}
          </div>
          <div className="mt-3 text-3xl font-semibold leading-none text-slate-900">
            {formatCell(value)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryCards;

